import React from "react";
import { createUseStyles } from "react-jss";
import Label from "../Label";

const useStyles = createUseStyles({
  textarea: {
    background: "#252525",
    border: "1px solid #707070",
    "border-radius": 3,
    color: "white",
    "font-size": 14,
    margin: [3, 0, 0, 0],
    padding: [5, 10],
    width: "100%",
    "max-width": "100%",
    height: 100,
    "box-sizing": "border-box",
  },
});

const TextArea = ({ label, required, optional, value, onChange, ...props }) => {
  const classes = useStyles();
  return (
    <Label name={label} required={required} optional={optional}>
      <textarea
        value={value ?? ""}
        className={classes.textarea}
        onChange={evt => onChange(evt.target.value)}
        {...props}
      />
    </Label>
  );
};

export default TextArea;
